import { useMutation } from '@tanstack/react-query';
import {
  type SendSmsInput,
  gqlClient,
  graphql,
  queryClient,
  resolveBackendError,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { smsKeys } from './keys';

const sendSms = graphql(/* GraphQL */ `
  mutation sendSms($input: SendSmsInput) {
    communications_sendSms(input: $input)
  }
`);

export function useSendSms() {
  const { t } = useTranslation(['sms']);

  return useMutation({
    mutationFn: (input: SendSmsInput) => gqlClient.request(sendSms, { input }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: smsKeys.all });
      toast.success(t('sms:smsSentSuccessfully'));
    },
    onError: async (error) => {
      const description = await resolveBackendError(error);
      toast.error(t('sms:smsFailedToSend'), { description });
    },
  });
}
